import Text from 'components/Text/Text';

import './FormError.scss';

interface Props {
  message: string;
}

const FormError: React.FC<Props> = ({message}) => {
  return (
    <div className="form-error" data-testid="form-error">
      <Text tag="span" className="form-error__message">
        {message}
      </Text>
    </div>
  );
};

export default FormError;
